module.exports = __webpack_public_path__ + "fonts/subset-mBank-SemiBold.255af9a4.woff";